import React, { useState, useEffect } from 'react';
import { Box, Typography, Switch } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { watchAction, unwatchAction } from './activitiesActions';

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#52d869',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: '#E34848',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => (
  <Switch
    focusVisibleClassName={classes.focusVisible}
    disableRipple
    classes={{
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked,
    }}
    checked={props.checked}
    onChange={props.onChange}
  />
));

function ActivityWatch(props) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    setActive(!!props.userWatched);
  }, [props.userWatched]);

  const toggle = async () => {
    const next = !active;
    setActive(next);
    try {
      if (next) {
        await props.watchAction(props.actionId);
      } else {
        await props.unwatchAction(props.actionId);
      }
    } catch (error) {
      setActive(!next);
    }
  };

  return (
    <Box display="flex" alignItems="center">
      <IOSSwitch checked={active} onChange={toggle} value="switch" />
      <Typography style={{ fontSize: 20, fontWeight: '400', color: '#000' }} variant="subtitle2">
        Ative a notificação desta atividade
      </Typography>
    </Box>
  );
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ watchAction, unwatchAction }, dispatch);
};

export default connect(null, mapDispatchToProps)(ActivityWatch);
